export class Lazy {
    constructor(f) {
        this.f = f;
        this._value = null;
        this._calculated = false;
    }
    get() {
        if (!this._calculated) {
            this._value = this.f();
            this._calculated = true;
        }
        return this._value;
    }
    hasValue() {
        return this._calculated;
    }
}
export class LazyAsync {
    constructor(f) {
        this.f = f;
        this._value_promise = null;
        this._calculated = false;
    }
    async get() {
        if (!this._value_promise) {
            this._value_promise = this.f();
            await this._value_promise;
            this._calculated = true;
        }
        return await this._value_promise;
    }
    hasValue() {
        return this._calculated;
    }
}
export function lazy(f) {
    return new Lazy(f);
}
export function async_lazy(f) {
    return new LazyAsync(f);
}
